import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
/** Joins class names; later Tailwind classes win over earlier ones (shadcn/ui convention). */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map